import { css, cx } from 'emotion';
import {
	desktopMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
	aqua,
	textBlock,
	headingMedium,
	quadrantsStyle,
	headingLarge,
} from 'inside-out/global-styles';

export const quadrantsWrapperStyle = cx(
	quadrantsStyle,
	css({
		maxWidth: desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '-70px auto',
		'& > section h1': {
			fontSize: '22px',
			lineHeight: '22px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			margin: '-40px auto',
		},
	})
);

export const missionTextStyle = cx(
	headingLarge,
	css({
		lineHeight: '36px',
		maxWidth: '1000px',
	})
);

export const titleStyle = cx(
	headingLarge,
	css({
		marginBottom: '31px',
		marginTop: '90px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			marginTop: '30px',
		},
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '70px auto',
	padding: '0 20px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		margin: '30px 0',
	},
});

export const bodyTextStyle = cx(
	textBlock,
	css({
		maxWidth: '800px',
		'& h2': cx(
			headingMedium,
			css({
				marginTop: '40px',
			})
		),
	})
);

export const ourKeyPillarsTitleStyle = cx(
	headingLarge,
	css({
		color: '#fff',
		lineHeight: '36px',
		textAlign: 'center',
		marginBottom: '48px',
	})
);

export const subTitleStyle = cx(
	headingMedium,
	css({
		lineHeight: '22px',
		marginBottom: '21px',
		marginTop: '40px',
	})
);

export const ourKeyPillarsStyle = css({
	background: aqua,
	padding: '94px 0',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '30px 0',
	},
});

export const ourKeyPillarsInnerStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
});

export const ourKeyPillarsCardStyle = css({
	background: '#fff',
	boxShadow: 'rgba(0,0,0,.18) 0 6px 12px 0',
	padding: '24px 26px',
	borderRadius: '8px',
	'& > div:first-child': {
		display: 'block',
		marginBottom: '21px',
		lineHeight: '60px',
		verticalAlign: 'middle',
	},
	'& > h2': cx(
		headingMedium,
		css({
			lineheight: '22px',
			marginBottom: '13px',
		})
	),
	'& > div:last-child': textBlock,
});



// WEBPACK FOOTER //
// ./src/page-styles/about-us/index.js